// src/app/services/language.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class LangService {
  private apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) {}

  // lang.service.ts
    async getLanguages(channelCode: string, lat?: number | null, lng?: number | null): Promise<{ code: string; name: string }[]> {
        const geo = (lat != null && lng != null) ? `&lat=${lat}&lng=${lng}` : '';
        const url = `${this.apiUrl}/langs?code=${channelCode}${geo}`;
        const headers = new HttpHeaders({
            'genlix': '570f31e7-55cb-482e-be09-52dae38a8db3'
        });

        try {
            const response: any[] = await firstValueFrom(this.http.get<any[]>(url, { headers }));
            return response.map(lang => ({ code: lang.code, name: lang.name || lang.title || lang.code }));
        } catch (error) {
            console.error('Error fetching languages:', error);
            return [];
        }
    }
}
